var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tech-analysis-container"},[_c('tab-header',{attrs:{"headerList":_vm.boss.techHeader,"currentTab":1},on:{"changeTabPage":_vm.changeTabPage}}),_c('technician-turnover'),_c('technician-statistics')],1)}
var staticRenderFns = []

export { render, staticRenderFns }